// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main-content .input-from .el-form-item__content {\n  width: 100%;\n  height: 100%;\n}\n.app-main-content .input-border {\n  height: 100%;\n}\n.app-main-content .input-border .el-textarea__inner {\n    width: 100%;\n    height: 100%;\n}\n.app-main-content .general-pagination .el-pager li.number.active {\n  color: blue !important;\n}\n", ""]);
// Exports
module.exports = exports;
